<template>
    <div class="width-full">
        <v-container fluid grid-list-xl class="container-symptoms-questions general-container">
            <v-layout row wrap class="navigation-header">
                <v-flex xs12>
                    <header-bar></header-bar>
                </v-flex>
            </v-layout>


                <v-layout row wrap class="general-info page-content with-alerts pf-standard-mobile pf-mobile-related-symptoms">
                    <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 class="no-padding">
                        <p class="page-title-pf no-margin-bottom hidden-xs-only">{{text('api.pdf.pageTitle.symptomsQuestions')}}</p>
                        <standard-stepper  :steps="step"></standard-stepper>
                        <description class="margin-top-xl"></description>
                    </v-flex>

                    <v-flex lg4 offset-lg4 md6 offset-md3 sm8 offset-sm2 class="no-padding-right no-padding-left">
                        <div class="main-symptom-section start-assessment-section-pf related-symptoms-page-pf symptom-questions-page-pf">
                            <v-card class="pf-related-symptoms">
                                <v-card-text class="general-content card-pdf">
                                        <v-card color="white"  v-for="symptom in selectedRelatedSymptomList" :key="symptom.code" >
                                            <v-card-text class="px-0 pf-question">

                                                <question-list-block
                                                    :questions="symptom.questionsData.questions"
                                                    :title="symptom.name"
                                                    :questionsCountAnswered="symptom.questionsData.countAnswered"
                                                    :questionsCountTotal="symptom.questionsData.countTotal"
                                                    titleClasses="symptom-name font-weight-bold font-size-default text-transform-none"
                                                    :symptomCode="symptom.code"
                                                    @onProvideAnswer="handleProvideAnswer">
                                                </question-list-block>
                                            </v-card-text>
                                        </v-card>
                                </v-card-text>

                                <v-card-actions class="pf-actions hidden-xs-only">
                                    <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn">
                                        <v-icon>keyboard_arrow_left</v-icon>
                                        {{ text('api.button.back') }}
                                    </v-btn>
                                    <v-btn flat color="primary" @click="goToNextPage"  class="footer-btn footer-btn-next">
                                        {{ text('api.button.evaluate')}}
                                        <v-icon>keyboard_arrow_right</v-icon>
                                    </v-btn>
                                </v-card-actions>
                            </v-card>
                        </div>
                    </v-flex>

                </v-layout>

            <v-layout>
                <v-flex>
                    <div class="footer pf-standard-mobile hidden-sm-and-up">

                        <v-btn flat color="grey darken-1" @click="goToPreviousPage" class="footer-btn back-pf">
                            <v-icon>keyboard_arrow_left</v-icon>
                            {{ text('api.button.back') }}
                        </v-btn>

                            <mobile-stepper :steps="step"></mobile-stepper>

                        <v-btn flat color="primary" @click="goToNextPage" class="footer-btn footer-btn-next next-pf">
                            {{ text('api.button.next') }}
                            <v-icon>keyboard_arrow_right</v-icon>
                        </v-btn>
                    </div>

                </v-flex>
            </v-layout>

        </v-container>

    </div>
</template>

<script>
    import HeaderBar from "../../shared/HeaderBar";
    import {mapGetters} from 'vuex';
    import QuestionListBlock from "../../../../common/components/shared/QuestionListBlockPf";
    import Description from '../../shared/Description';
    import StandardStepper from '../../shared/StandardStepper';
    import MobileStepper from '../../shared/MobileStepper';

    export default {
        name: "SymptomsQuestionsPage",
        components: {
            HeaderBar,
            QuestionListBlock,
            Description,
            StandardStepper,
            MobileStepper
        },
        data() {
            return {
                step: 5,
            }
        },
        computed: {
            ...mapGetters({
                selectedRelatedSymptomList: 'PfSymptomsQuestionsStore/getSelectedRelatedSymptomList',
                isFooterNextBtnEnabled: 'PfSymptomsQuestionsStore/getIsFooterNextBtnEnabled',
            })
        },
         methods: {

             goToPreviousPage() {
                 this.$router.push('/pathfinder/related-symptoms');
             },

             goToNextPage() {
                 this.$router.push('/pathfinder/shared-questions');
             },

             handleProvideAnswer(data) {
                 this.$store.dispatch('PfSymptomsQuestionsStore/submitSymptomQuestionAnswer', data);
             }

         },
        created() {
            this.$store.dispatch("PfSymptomsQuestionsStore/loadSymptomsQuestionsData")
        }
    }
</script>

<style scoped lang="scss">

    .pf-related-symptoms {

        .general-content {
            padding: 10px 20px 20px !important;

            .card {
                box-shadow: none !important;
                margin-top: 15px;
                padding: 0 !important;

                .card__text:first-child {
                    border-top: none !important;
                }

                .card__text {

                    .question-item{
                        margin: 7px 0;
                    }

                }
            }
        }
    }

    .scrolling-content {
        overflow: hidden !important;
    }

    .scrolling-content.path {
        top: 110px !important;
    }

    .card-pdf .card.white {
        height: auto;
    }

    @media only screen and (max-width: 600px) {
        .pf-standard-mobile.pf-mobile-related-symptoms {
            margin-top: 0 !important;
            background-color: $color-gray-lightest;
        }

        .footer-btn-next.next-pf {
            position: absolute;
            right: 0;
            bottom: 4px;
        }

        .footer-btn.back-pf {
            position: absolute;
            top: 4px;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }

        .main-symptom-section.start-assessment-section-pf.related-symptoms-page-pf{

            height: auto !important;
            margin-bottom: 0 !important;
            padding: 0;

            .pf-related-symptoms {

                .card__text.general-content {
                    height: calc(100vh - 247px) !important;
                    overflow: auto;
                }

            }

        }

        .pf-related-symptoms {

            .general-content {
                height: auto !important;
            }
        }
    }

    @media only screen and (min-width: 601px) {

        .pf-related-symptoms {

            .general-content {
                padding: 10px 20px 20px !important;
                height: 500px !important;
                overflow: auto !important;
            }
        }

        .symptom-questions-page-pf {

            padding: 0;

            .pf-related-symptoms {

                height: 100% !important;

                .general-content {
                    height: calc(100% - 60px) !important;
                    padding: 70px 20px 20px !important;
                }

                .card__actions {
                    height: 60px !important;
                    position: absolute;
                    bottom: 0;
                }
            }
        }

        .symptom-questions-page-pf .questions {
            padding: 0 20px !important;
        }

        .pf-standard-mobile {
            .footer-btn-next {
                background-color: $color-block-background;
                color: $color-brand-primary;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/pathfinder/components/standard-forms/symptom-questions/SymptomsQuestionsPage.vue